const debounce = (func, wait, options = {}) => {
  let timeout, lastCallTime;
  const { maxWait } = options;

  return function (...args) {
    const now = Date.now();

    if (!lastCallTime || (maxWait && now - lastCallTime >= maxWait)) {
      lastCallTime = now;
      func.apply(this, args);
    } else {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        lastCallTime = Date.now();
        timeout = null;
        func.apply(this, args);
      }, wait);
    }
  };
};

const debouncedResize = debounce(
  () => {
    const resizeEvent = new Event('resize');
    window.dispatchEvent(resizeEvent);
  },
  250,
  { maxWait: 250 },
);

window.debouncedResize = debouncedResize;

export { debouncedResize };
